const TOPICS = [
  { name: '娱乐圈吃瓜', count: '3.2万', hot: true },
  { name: '品牌代言人翻车', count: '2.8万', hot: true },
  { name: '互联网大厂内幕', count: '2.5万', hot: true },
  { name: '网红主播造假', count: '2.1万', hot: false },
  { name: '食品安全曝光', count: '1.9万', hot: false },
  { name: '影视综艺黑幕', count: '1.7万', hot: false },
  { name: '职场潜规则', count: '1.5万', hot: false },
  { name: '房产楼市争议', count: '1.4万', hot: false },
  { name: '科技产品缺陷', count: '1.2万', hot: false },
  { name: '教育培训乱象', count: '1.1万', hot: false },
  { name: '出行服务纠纷', count: '0.9万', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">热门话题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          当前爆料大赛讨论最热烈的话题标签
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic, i) => (
            <div
              key={i}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all border ${
                topic.hot
                  ? 'bg-accent-50 border-accent-200 hover:bg-accent-100 hover:border-accent-300'
                  : 'bg-background-100 border-background-200 hover:bg-background-200/60 hover:border-background-300'
              }`}
            >
              {topic.hot && (
                <i className="ri-fire-line text-accent-500 text-sm flex-shrink-0"></i>
              )}
              <span className={`text-sm font-medium whitespace-nowrap ${
                topic.hot ? 'text-accent-800' : 'text-foreground-700'
              }`}>
                #{topic.name}
              </span>
              <span className={`text-xs whitespace-nowrap ${
                topic.hot ? 'text-accent-500' : 'text-foreground-400'
              }`}>
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}